/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicB2cV1SaveOffersFromListingRequest,
  TPublicB2cV1SaveOffersFromListingModel,
  IMappers,
  TPublicB2cV1SaveOffersFromListingResponse_,
  TPublicB2cV1SaveOffersFromListingResponse,
  TPublicB2cV1SaveOffersFromListingResponse_1,
  TPublicB2cV1SaveOffersFromListingResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createPublicB2cV1SaveOffersFromListingModel(
  parameters: TPublicB2cV1SaveOffersFromListingRequest,
): TPublicB2cV1SaveOffersFromListingModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'mortgage-broker-calculator',
    pathApi: '/b2c/v1/save-offers-from-listing/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicB2cV1SaveOffersFromListingOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicB2cV1SaveOffersFromListingRequest;
}

export async function fetchPublicB2cV1SaveOffersFromListing<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicB2cV1SaveOffersFromListingOptions<TResponse200, TResponse400>): Promise<
  TPublicB2cV1SaveOffersFromListingResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicB2cV1SaveOffersFromListingModel(parameters),
    config,
  )) as FetchResponse<TPublicB2cV1SaveOffersFromListingResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublicB2cV1SaveOffersFromListingResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TPublicB2cV1SaveOffersFromListingResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TPublicB2cV1SaveOffersFromListingResponse;
}
